
app.formsController = app.formsController || {};
app.formsController.defaultAction = {

    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        if ($('select').length > 0) {
            // Transform selects on no-touch devices
            // $('select').customSelect();
        }

        if ($('select').length > 0) {
            this.transformSelect();
        }
        if ($('[type="checkbox"]').length > 0) {
            this.transformCheck();
        }
        if ($('[type="radio"]').length > 0) {
            this.transformRadio();
        }
        if ($('[type="file"]').length > 0) {
            this.transformFile();
        }
    },

    transformSelect : function () {
        $select = $('select');
        $select.each(function(){
            $sel = $(this);
            $sel.wrap('<span class="dummySelect"></span>').after('<span class="dummySelected fld">'+$sel.find(':selected').text()+'</span>');
            $sel.on('change', function(e){
                $this = $(e.target);
                $this.next('.dummySelected').text($this.find(':selected').text());
            });
        });
    },

    transformCheck : function () {
        $checkbox = $('[type="checkbox"]');
        $checkbox.each(function(){
            $check = $(this);
            $check.wrap('<span class="dummyCheck"></span>').after('<span class="dummySelected"></span>');
        });
    },

    transformRadio : function () {
        $radio = $('[type="radio"]');
        $radio.each(function(){
            $radio = $(this);
            $radio.wrap('<span class="dummyRadio"></span>').after('<span class="dummySelected"></span>');
        });
    },

    transformFile : function () {
        $file = $('[type="file"]');
        $file.each(function(){
            var $sel = $(this),
                label = $sel.parents('.formItem').find('label').text(),
                value = $sel.val() ? $sel.val() : "… Choisissez un fichier";
            $sel.wrap('<span class="dummyFile"></span>').after('<span class="dummyDownload fld"></span>');
            $sel.next('.dummyDownload').append('<span class="dummyBtn">'+label+'</span>').append('<span class="dummySelected">'+value+'</span>');
            $sel.on('change', function(e){
                $this = $(e.target);
                $this.next('.dummyDownload').find('.dummySelected').text($this.val());
            });
        });
    },

};

$(document).ready(function(){
    app.formsController.defaultAction.init();
});
